import type { ComponentPropsWithoutRef } from 'react'
import { MdNavigateNext, MdNavigateBefore } from 'react-icons/md'
import styled from 'styled-components'

import { theme } from '@/styles/theme'

type Props = {
  page: number | 'next' | 'before'
  isActive?: boolean
} & ComponentPropsWithoutRef<'button'>

export const PaginationButton = ({ page, isActive, ...props }: Props) => {
  if (page === 'next') {
    return (
      <li>
        <ArrowButton type="button" {...props} aria-label="次のページ">
          <NextIcon />
        </ArrowButton>
      </li>
    )
  }

  if (page === 'before') {
    return (
      <li>
        <ArrowButton type="button" {...props} aria-label="前のページ">
          <BeforeIcon />
        </ArrowButton>
      </li>
    )
  }

  return (
    <li>
      <Button
        type="button"
        aria-current={isActive ? 'page' : undefined}
        {...props}
      >
        {page}
      </Button>
    </li>
  )
}

const Button = styled.button`
  display: grid;
  place-content: center;
  width: 46px;
  height: 44px;
  font-size: 16px;
  line-height: 27px;
  border: 1px solid ${theme.colors.trialBlue};
  background-color: #ffffff;
  color: ${theme.colors.trialBlue};
  border-radius: 2px;
  cursor: pointer;
  transition: all 0.3s ease-out;

  &:hover {
    background-color: ${theme.colors.trialBlue};
    color: #ffffff;

    > svg {
      color: #ffffff;
    }
  }

  &[aria-current='page'] {
    background-color: ${theme.colors.trialBlue};
    color: #ffffff;
    cursor: initial;
    pointer-events: none;
  }
`

const ArrowButton = styled(Button)`
  display: grid;
  place-content: center;
`

const NextIcon = styled(MdNavigateNext)`
  color: ${theme.colors.trialBlue};
  font-size: 22px;
`

const BeforeIcon = styled(MdNavigateBefore)`
  color: ${theme.colors.trialBlue};
  font-size: 22px;
`
